import React, { useState, useEffect, useRef, useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UALContext } from 'ual-reactjs-renderer';
import CalculatorComponent from "./components/CalculatorComponent/CalculatorComponent";
import MarketComponent from "./components/MarketComponent/MarketComponent";
import HeaderComponent from "./components/HeaderComponent/HeaderComponent";
import ModelResultComponent from "./components/ModelResultComponent/ModelResultComponent";
import useGetAllSpinnerInGame from './components/Wax/useGetAllSpinnerInGame';
import useGetAllRunesInGame from './components/Wax/useGetAllRunesInGame';
import useGetUserInfoInGame from './components/Wax/useGetUserInfoInGame';
import useGetSpnWax from './components/Wax/useGetSpnWax';
import UserBalance from './components/Wax/UserBalance';
import useGetAllPromo from './components/Wax/useGetAllPromo';
import beer from './img/bear.gif'
import './App.scss'

//import { ExplorerApi } from "atomicassets" // атомик для списка панд
//import { JsonRpc } from 'eosjs'
//const api = new ExplorerApi("https://wax.api.atomicassets.io", "atomicassets", { fetch, rateLimit: 4 });

import { arrRpcAt, savedOptionAt } from './components/Wax/Variables';
const { ExplorerApi, RpcApi } = require("atomicassets");
var numRpc = 0;


const templateIds = [
  761126,
  749979,
  749981,
  749982,
  749983,
  749984,
  716921,
  716922,
  750023,
  716924,
  716925,
  716926
];

const App = () => {


  const [accountName, setAccountName] = useState(null);
  const [stateUser, setStateUser] = useState(null);
  const [closeMod, setCloseMod] = useState(false);

  const [userInGameState, setUserInGame] = useState([]);
  const [allSpinnerInGame, setAllSpinnerInGame] = useState([]);
  const [allRunesInGame, setAllRunesInGame] = useState([]);

  const [modalResulOpen, setModalResulOpen] = useState(false);

  const [prices, setPrice] = useState([]);
  const [pricesHist, setPriceHist] = useState([]);

  const [spendSpn, setSpendSpn] = useState(0);
  const [getSpn, setGetSpn] = useState(0);
  const [allSlotPrice, setAllSlotPrice] = useState(0);

  const [spnCurr, setSpnCurr] = useState(null);
  const [waxprice, setWaxPrice] = useState(0);

  const [bal, setBal] = useState(null);

  const ual = useContext(UALContext);
  const login = () => {
    ual.logout();
    ual.showModal();
  }
  const logout = () => {
    ual.logout();
    setAccountName(null);
  }

  const closeModal = (e) => {
    setCloseMod(e);
  }

  useEffect(() => {
    if (ual?.activeUser?.accountName !== null && ual?.activeUser?.accountName !== accountName && ual?.activeUser?.accountName !== undefined) {
      setAccountName(ual.activeUser.accountName);
    }
  }, [ual]);

  const [refreshKey2, setRefreshKey2] = useState(0);
  const [refreshKey3, setRefreshKey3] = useState(0);
  const { allSpinnerInGameGet } = useGetAllSpinnerInGame(accountName, refreshKey2);
  const { allRunesInGameGet } = useGetAllRunesInGame(accountName);
  let { userInGame } = useGetUserInfoInGame(accountName, refreshKey3);
  let { tacoCurr } = useGetSpnWax();

  const balance = UserBalance("gcn4w.c.wam");
  //const balance = UserBalance("tonyhamnksrt");

  useEffect(() => {
    setBal(balance);
    //console.log("balance", balance)
  }, [balance]);

  useEffect(() => {
    if (userInGame && userInGame.length) {
      let array = userInGame.map(obj => ({ ...obj, storageBal: 0 }));
      setUserInGame(array);
    }
  }, [userInGame]);

  useEffect(() => {

    if (userInGame && userInGame.length) {
      setAllSpinnerInGame(allSpinnerInGameGet);

      let allSpinners = allSpinnerInGameGet.length;
      let storageBalance = 0;
    }
  }, [allSpinnerInGameGet, userInGame]);

  useEffect(() => {
    setAllRunesInGame(allRunesInGameGet);
  }, [allRunesInGameGet]);

  // const getAll = (page = 1, allData = []) => {
  //   const url = `https://wax.api.atomicassets.io/atomicmarket/v2/sales?state=3&collection_name=spinniaworld&after=1659821910000&page=${page}&limit=100&order=desc&sort=updated`;

  //   return fetch(url)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log("Data from page", page, data);

  //       // Добавляем полученные данные к общему массиву
  //       if (data.data.length === 0) {
  //         return allData;
  //       }

  //       // Добавляем полученные данные к общему массиву
  //       allData = allData.concat(data.data);

  //       // Вызываем getAll для следующей страницы
  //       return getAll(page + 1, allData);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };


  const getList = (tmpl) => {
    //https://wax.api.atomicassets.io/atomicmarket/v2/sales?collection_name=spinniaworld&page=1&limit=100&order=desc&sort=created
    return fetch(`https://wax.api.atomicassets.io/atomicmarket/v2/sales?state=1&collection_name=spinniaworld&template_id=${tmpl}&page=1&limit=1&order=asc&sort=price`)
      .then((response) => response.json())
      .then((getHead) => {
        //console.log("getHead", getHead);

        if (getHead.data && getHead.data.length > 0) {
          // Извлекаем только необходимые данные
          const item = getHead.data[0];
          return {
            template_id: tmpl, // Пример поля, которое вы хотите сохранить
            price: item.listing_price, // Еще одно поле, которое вам нужно
            // Другие поля по необходимости
          };
        } else {
          return {
            template_id: tmpl, // Пример поля, которое вы хотите сохранить
            price: 0, // Еще одно поле, которое вам нужно

          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getListHistory = (tmpl) => {
    return fetch(`https://wax.api.atomicassets.io/atomicmarket/v2/sales?state=3&collection_name=spinniaworld&template_id=${tmpl}&page=1&limit=1&order=desc&sort=updated`)
      .then((response) => response.json())
      .then((getHead) => {
        //console.log("getHead", getHead);
        //console.log("tmpl", tmpl);

        if (getHead.data && getHead.data.length > 0) {
          // Извлекаем только необходимые данные
          const item = getHead.data[0];
          return {
            template_id: tmpl, // Пример поля, которое вы хотите сохранить
            price: item.listing_price, // Еще одно поле, которое вам нужно
            // Другие поля по необходимости
          };
        } else {
          return {
            template_id: tmpl, // Пример поля, которое вы хотите сохранить
            price: 0, // Еще одно поле, которое вам нужно

          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (tacoCurr && tacoCurr.id !== undefined) {
      setSpnCurr(tacoCurr);

      let spn = parseInt(tacoCurr.pool1.quantity.replace(/\D/g, '')) * 10000;
      let wax = parseInt(tacoCurr.pool2.quantity.replace(/\D/g, ''));

      function truncateToDecimalPlace(num, decimalPlaces) {
        const power = Math.pow(10, decimalPlaces);
        const truncatedNum = Math.floor(num * power) / power;
        return truncatedNum.toFixed(decimalPlaces);
      }

      let cut = truncateToDecimalPlace(wax / spn, 8);

      setWaxPrice(wax / spn);
    }
  }, [tacoCurr]);


  useEffect(() => {
    Promise.all(templateIds.map(id => getList(id)))
      .then(results => {
        // results содержит массив результатов для каждого шаблона
        //console.log(results);
        setPrice(results);
      })
      .catch(error => {
        console.error("Ошибка при получении шаблонов: ", error);
      });


    Promise.all(templateIds.map(id => getListHistory(id)))
      .then(results => {
        // results содержит массив результатов для каждого шаблона
        //console.log(results);
        setPriceHist(results);
      })
      .catch(error => {
        console.error("Ошибка при получении шаблонов: ", error);
      });

    const processData = (data) => {
      const userPurchases = {};

      data.forEach(item => {
        const buyer = item.buyer;
        const price = parseInt(item.listing_price);

        if (userPurchases[buyer]) {
          userPurchases[buyer] += price;
        } else {
          userPurchases[buyer] = price;
        }
      });

      const sortedPurchases = Object.entries(userPurchases)
        .map(([buyer, total]) => ({ buyer, total }))
        .sort((a, b) => b.total - a.total);

      return sortedPurchases;
    };


    // getAll()
    //   .then((allData) => {
    //     console.log("allData", allData)
    //     const userPurchases = processData(allData);
    //     console.log("Purchases by user:", userPurchases);
    //   })
    //   .catch(error => {
    //     console.error("Ошибка при получении шаблонов: ", error);
    //   });
  }, []);

  return (
    <>

      <BrowserRouter>
        <div className="app-wrapper">
          <div className="wrapper">

            {
              !closeMod && !accountName ?
                <div className='login-fix'>
                  <div className="login-fix-in">
                    <div className="login-title">
                      Login
                    </div>
                    <div className="info-login">
                      <div className="info-login-text">
                        you can log in and see all your spins in the calculator
                      </div>
                      <div className="info-login-bt">
                        <button onClick={() => login()}>Login</button>
                      </div>
                    </div>
                    <div className="info-login">
                      <div className="info-login-text">
                        Or you can just use the calculator from scratch but you won't be able to see your spinies
                      </div>
                      <div className="info-login-bt">
                        <button onClick={() => closeModal(true)}>continue without authorization</button>
                      </div>
                    </div>
                  </div>
                </div>
                : null
            }



            {accountName || closeMod ?

              <>
                <HeaderComponent
                  spendSpn={spendSpn}
                  getSpn={getSpn}
                  login={login}
                  logout={logout}
                  closeMod={closeMod}
                  accountName={accountName}
                  closeModal={closeModal}
                  spnCurr={spnCurr}
                  waxprice={waxprice}
                  setModalResulOpen={setModalResulOpen}
                />
                <Routes>
                  <Route path="" element={<CalculatorComponent
                    allSpinnerInGame={allSpinnerInGame}
                    setSpendSpn={setSpendSpn}
                    setGetSpn={setGetSpn}
                    prices={prices}
                    pricesHist={pricesHist}
                    setAllSlotPrice={setAllSlotPrice}
                    accountName={accountName}
                    ual={ual}
                  />} />
                  <Route path="/market" element={<MarketComponent
                    prices={prices}
                    pricesHist={pricesHist}
                    allSpinnerInGame={allSpinnerInGame}
                    setSpendSpn={setSpendSpn}
                    setGetSpn={setGetSpn}
                  />} />
                </Routes>

              </>
              : <Navigate to="/" />
            }

            {modalResulOpen ?
              <ModelResultComponent
                spendSpn={spendSpn}
                getSpn={getSpn}
                waxprice={waxprice}
                allSlotPrice={allSlotPrice}
                setModalResulOpen={setModalResulOpen}
              /> : null}

            <div className="donation">
              <div className="dotation-tit">
                buy me a beer
              </div>
              <div className="don-img">
                <img src={beer} alt="" />
              </div>
              <div className="donation-info">
                already in my wallet:
              </div>
              <div className="donation-wax">
                {bal && bal !== "NaN" ? bal : 0} WAX
              </div>
              <div className="donation-wal">
                my Wallet: <span>gcn4w.c.wam</span>
              </div>
              {/* <div className="donation-bt">
                <span className='bt'>
                  donat
                </span>
              </div> */}
            </div>

            {/* <Routes>

              {accountName && accountName != undefined && accountName != null ?
                stateUser && stateUser.user == undefined || stateUser == null ?
                  // Если не зареган
                  "no reg"
                  // <Route path="" element={<RegisterForm accountName={accountName} reguser={reguser} />} />
                  :
                  "reg"
                : "no LOG"
              }
            </Routes> */}


          </div>

          <footer>
            <div class="wrapper">
              alpha version 0.1 of the calculator for spinneyworld
            </div>
          </footer>

        </div>
      </BrowserRouter>
    </>
  )
}
// ---

export default App
